import { render, staticRenderFns } from "./payrollWarn.vue?vue&type=template&id=cdf74cdc&"
import script from "./payrollWarn.vue?vue&type=script&lang=js&"
export * from "./payrollWarn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports